import { motion } from "framer-motion";

const blocks = [
  {
    title: "Rane Technical",
    items: [
      "Technical collaboration with Nisshinbo Brakes Inc, Japan — know-how in asbestos-free brake linings, disc pads & clutch facings.",
      "Application in every segment of the automobile industry.",
    ],
  },
  {
    title: "Domestic Market Leadership · India",
    items: [
      "Leader in Commercial Vehicle, Passenger Car, Utility Vehicle & Two-Wheeler applications.",
      "Most preferred brand in independent replacement markets.",
      "Leading supplier of composite brake blocks to Indian Railways.",
      "Significant supplier to State Transport Undertakings.",
    ],
  },
  {
    title: "Exports",
    items: [
      "Products supplied to 30+ countries.",
      "Range & technology for Indian / European Commercial Vehicle references.",
      "Supply experience to Indian and Sri Lankan Railways for composite brake blocks.",
      "CV disc brake pads exported to Europe.",
    ],
  },
];

export default function RaneSection({ variant = "default" }) {
  return (
    <section
      data-testid="rane-section"
      className={`relative py-20 md:py-28 ${
        variant === "alt" ? "bg-[#B8CCE0]" : "bg-white"
      } border-y border-[#D5DEE8]`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Left: Logo + intro */}
          <div className="col-span-12 lg:col-span-5">
            <p className="overline-maroon mb-4">Official Partner</p>

            <a
              href="https://ranegroup.com/"
              target="_blank"
              rel="noreferrer"
              data-testid="rane-logo-link"
              className="inline-block bg-white border border-[#D5DEE8] p-6 md:p-8 hover:border-[#B8860B] transition-colors shadow-sm"
            >
              <img
                src="/brand/rane-logo.png"
                alt="Rane Group — Expanding Horizons"
                className="h-20 md:h-24 w-auto object-contain"
              />
            </a>

            <h3 className="mt-7 font-serif-display font-light text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[#0F1E33]">
              OMC LTD <span className="italic text-[#1E3A5F]">× Rane</span>
            </h3>
            <div className="hairline-gold w-20 mt-5" />
            <p className="mt-5 text-[#1F2D40] text-base md:text-lg leading-relaxed max-w-xl">
              OMC LTD is an <strong className="text-[#0F1E33]">official partner</strong>{" "}
              for the aftermarket products of Rane — brake components and other
              OE parts — serving as the aftermarket division for the UK and
              Europe.
            </p>
          </div>

          {/* Right: 3 info blocks */}
          <div className="col-span-12 lg:col-span-7 space-y-5">
            {blocks.map((b, idx) => (
              <motion.div
                key={b.title}
                data-testid={`rane-block-${idx}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                className={`${
                  variant === "alt" ? "bg-white" : "bg-[#D6E2F0]"
                } border border-[#D5DEE8] p-6 md:p-7 hover:border-[#B8860B] transition-colors`}
              >
                <div className="flex items-baseline gap-3 mb-3">
                  <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B8860B]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <h4 className="font-serif-display text-xl md:text-2xl text-[#0F1E33] tracking-tight">
                    {b.title}
                  </h4>
                </div>
                <ul className="space-y-2 md:space-y-2.5">
                  {b.items.map((it) => (
                    <li key={it} className="flex gap-3 items-start">
                      <span className="mt-2 w-1.5 h-1.5 bg-[#1E3A5F] shrink-0" />
                      <span className="text-sm md:text-base text-[#1F2D40] leading-relaxed">
                        {it}
                      </span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
